import { validateEmail as validateEmailShared } from '@getaccept/lib-shared-new/src/helpers';
import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
import type { Participant } from '@getaccept/dsr-shared-new';

export class ShareHelper {
  static validateEmail = (
    email: string,
    roomParticipants: Participant[],
    participantsToInvite: { email: string }[]
  ) => {
    if (roomParticipants.some(p => p.email === email)) {
      return t('participant_already_in_room');
    }
    if (participantsToInvite.filter(p => p.email === email).length > 1) {
      return t('email_already_added');
    }
    if (!!email && !validateEmailShared(email)) {
      return t('enter-a-valid-email');
    }
    return '';
  };
}
